import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

export interface IRouterParams {
  token: string;
}

const AzureAD = () => {
  fetch('https://localhost:8080/api/bankid/auth').then(function (response) {
    console.debug(response);
  });

  console.debug(useParams());

  const { token } = useParams();

  return <h2>Token: {token}</h2>;
};

export default connect()(AzureAD);
